<template>
  <div>
    <article class="slds-card">
      <Spinner v-if="!users.length" />

      <div v-else>
        <div class="slds-card__header slds-grid">
          <header class="slds-media slds-media_center slds-has-flexi-truncate">
            <div class="slds-media__figure">
              <span
                class="slds-icon_container slds-icon-standard-user"
                :title="$t('usersManagement.users')"
              >
                <svg
                  class="slds-icon slds-icon-action-user"
                  aria-hidden="true"
                >
                  <use xlink:href="../assets/symbols.svg#einstein"></use>
                </svg>
                <span class="slds-assistive-text">{{$t('usersManagement.users')}}</span>
              </span>
            </div>
            <div class="slds-media__body">
              <h2 class="slds-card__header-title">
                <span
                  class="slds-card__header-link slds-truncate"
                  :title="$t('usersManagement.users')"
                >
                  <span>{{$t('usersManagement.users')}}</span>
                </span>
              </h2>
            </div>
            <div class="slds-no-flex">
              <button class="slds-button slds-button_brand" @click="createNewUser">{{ $t('action.new') }}</button>
            </div>
          </header>
        </div>
        <div class="slds-card__body slds-card__body_inner">
          <article class="slds-card slds-card_boundary filter-panel">
            <div class="slds-card__body slds-card__body_inner">
              <div class="slds-form-element">
                <SLDSInput
                  :placeholder="$t('action.filter')"
                  has-left-icon
                  type="text"
                  v-model="searchKey"
                >
                  <use
                    xlink:href="../assets/symbols.svg#search"
                    slot="leftIcon"
                  ></use>
                </SLDSInput>
              </div>

              <div class="row">
                <Picklist
                  :label="$t('usersManagement.filters.status.label')"
                  :options="settings.active"
                  include-all-value
                  labels-prefix="usersManagement.filters.active"
                  v-model="filters.active"
                />

                <Picklist
                  :label="$t('usersManagement.user.countries')"
                  :options="settings.markets"
                  include-all-value
                  labels-prefix="markets"
                  multipicklist
                  v-model="filters.countries"
                />

                <Picklist
                  :label="$t('usersManagement.user.role')"
                  :options="settings.role"
                  include-all-value
                  labels-prefix="usersManagement.user.roles"
                  v-model="filters.role"
                />
              </div>
            </div>

          </article>

          <UsersTable
            class="users-table"
            v-model="filteredUsers"
            @edit="editRow"
            @deleteUser="deleteUser"
            @sortChange="changeSortingOptions"
            :sorting-options="sortingOptions"
          />

          <!--<SfmcUsersTable
            class="users-table"
            v-model="filteredUsers"
            @copy="copySfmcId"
            @sortChange="changeSortingOptions"
            :sorting-options="sortingOptions"
          />-->
        </div>
      </div>
    </article>

    <transition name="fade">
      <Modal
        v-if="showModal"
        :title="$t('usersManagement.editUser')"
        @close="closeModal"
        @neutralButtonClick="cancelUserEdit"
        @positiveButtonClick="saveUser"
        :positive-button-text="$t('action.save')"
        :neutral-button-text="$t('action.cancel')"
        >
        <SLDSInput
          :label="$t('usersManagement.user.name')"
          v-model="selectedUser.name"
          disabled
        />
        <SLDSInput
          :label="$t('usersManagement.user.email')"
          v-model="selectedUser.email"
          disabled
        />

        <Picklist
          labels-prefix="markets"
          multipicklist
          ref="countries"
          searchable
          v-model="selectedUser.countries"
          :label="$t('usersManagement.user.countries')"
          :options="settings.markets"
          :validation="[{name: 'conditional-required', param: selectedUser.active, message: 'validation.custom.conditionalRequiredUserManagement'}]"
        />

        <Picklist
          :label="$t('usersManagement.user.role')"
          :options="settings.role"
          labels-prefix="usersManagement.user.roles"
          v-model="selectedUser.role"
        />

        <!--<IncludedFilter
          :label="$t('usersManagement.user.visibility')"
          v-model="selectedUser.visibility" />-->

        <Picklist
          :label="$t('usersManagement.user.visibility')"
          :options="settings.visibility"
          v-model="selectedUser.visibility"
          multipicklist
        />

        <SLDSInput
          type="checkbox"
          :label="$t('usersManagement.user.active')"
          v-model="selectedUser.active"
        />
      </Modal>
    </transition>
    
    <transition name="fade">
      <Modal
        v-if="showDeleteModal"
        @close="closeDeleteModal"
        @destructiveButtonClick="doDeleteUser"
        :destructiveButtonText="$t('action.delete')"
        :title="$t('usersManagement.deleteUser')">
        <div class="slds-text-heading_small slds-text-align_center">
          {{$t('usersManagement.deleteUserConfirm')}}
        </div>
      </Modal>
    </transition>
    
    <transition name="fade">
      <Modal
        v-if="showNewUserModal_getID"
        :title="$t('usersManagement.newUser')"
        @close="closeNewUserModal"
        @neutralButtonClick="cancelNewUser"
        @positiveButtonClick="continueNewUser"
        :positive-button-text="$t('action.continue')"
        :neutral-button-text="$t('action.cancel')"
        >
        <div class="row">
          <SLDSInput id="input_searchSfmcUser"
            :label="$t('usersManagement.user.email')"
            v-model="newUser.email"
            :validation="['required']"          
          />
          <button class="slds-button slds-button_neutral" @click="getNewUserSub" id="btn_searchSfmcUser">
            <svg class="slds-button__icon" aria-hidden="true">
              <use  xlink:href="../assets/symbols.svg#search" slot="leftIcon"></use>
            </svg>
          </button>
        </div>
        <SLDSInput
          :label="$t('usersManagement.user.sub')"
          v-model="newUser.sub"
          :validation="['required']"  
          disabled        
        />
        <SLDSInput
          :label="$t('usersManagement.user.name')"
          v-model="newUser.name"
          disabled        
        />
        
          <!--<div class="slds-path slds-m-top--small"  v-if="this.sfmcUsers.length>1">
            <div class="row">
              <button
                class="slds-button slds-button_neutral"
                @click="goToPreviousSfmcUser"
                :disabled="isPreviousButtonDisabled"
              >{{ $t('action.back') }}</button>
              <span>&nbsp; {{ this.sfmcUsers.findIndex(u=>u.ID === this.newUser.sub)+1 }}/{{ this.sfmcUsers.length }} &nbsp;</span>
              <button
                class="slds-button slds-button_neutral"
                @click="goToNextSfmcUser"
                :disabled="isNextButtonDisabled"
              >{{ $t('action.next') }}</button>
            </div>
          </div>-->
          
          <div v-if="this.sfmcUsers.length>1" class="pagination-section slds-m-top--medium" :style="`text-align: -webkit-center;`">
            <div id="div_paginationSearchSfmcUser" :style="`width: fit-content;`">
              <!--<button class="slds-button slds-button_neutral" @click="goToFirstPage" :disabled="pageNumber === 0"> &lt;&lt; </button>-->
              <button class="slds-button slds-button_neutral slds-m-right--small" @click="goToPreviousSfmcUser" :disabled="isPreviousButtonDisabled"> &lt; </button>
              <span>&nbsp; {{ this.sfmcUsers.findIndex(u=>u.ID === this.newUser.sub)+1 }}/{{ this.sfmcUsers.length }} &nbsp;</span>
              <button class="slds-button slds-button_neutral slds-m-left--small" @click="goToNextSfmcUser" :disabled="isNextButtonDisabled"> &gt; </button>
              <!--<button class="slds-button slds-button_neutral" @click="goToLastPage" :disabled="isNextButtonDisabled"> &gt;&gt; </button>-->
            </div>
          </div>
      </Modal>
    </transition>
    <transition name="fade">
      <Modal
        v-if="showNewUserModal"
        :title="$t('usersManagement.newUser')"
        @close="closeNewUserModal"
        @neutralButtonClick="cancelNewUser"
        @positiveButtonClick="saveNewUser"
        @destructiveButtonClick="backNewUser"
        :positive-button-text="$t('action.save')"
        :destructive-button-text="$t('action.back')"
        :neutral-button-text="$t('action.cancel')"
        >
        <SLDSInput
          :label="$t('usersManagement.user.sub')"
          v-model="newUser.sub"
          :validation="['required']"     
          disabled     
        />
        <SLDSInput
          :label="$t('usersManagement.user.name')"
          v-model="newUser.name"
          :validation="['required']"
          disabled
        />
        <SLDSInput
          :label="$t('usersManagement.user.email')"
          v-model="newUser.email"
          :validation="['required']"
          disabled
        />

        <Picklist
          labels-prefix="markets"
          multipicklist
          ref="countries"
          searchable
          v-model="newUser.countries"
          :label="$t('usersManagement.user.countries')"
          :options="settings.markets"
          :validation="[{name: 'conditional-required', param: newUser.active, message: 'validation.custom.conditionalRequiredUserManagement'}]"
        />

        <Picklist
          :label="$t('usersManagement.user.role')"
          :options="settings.role"
          ref="role"
          labels-prefix="usersManagement.user.roles"
          v-model="newUser.role"
          :validation="['required']"
        />

        <Picklist
          :label="$t('usersManagement.user.visibility')"
          :options="settings.visibility"
          v-model="newUser.visibility"
          multipicklist
        />

        <Picklist
          :label="$t('usersManagement.user.locale')"
          :options="settings.locale"
          ref="locale"
          v-model="newUser.locale"
          :validation="['required']"
        />

        <SLDSInput
          type="checkbox"
          :label="$t('usersManagement.user.active')"
          v-model="newUser.active"
        />
      </Modal>
    </transition>

  </div>
</template>
<script>
import _ from 'lodash'
import IncludedFilter from '../components/campaign-manager/filters/IncludedFilter'
import Modal from '../components/Modal'
import Input from '../components/slds/Input'
import Spinner from '../components/Spinner'
import Picklist from '../components/slds/Picklist'
import UsersTable from '../components/users-management/UsersTable'
import SfmcUsersTable from '../components/users-management/SfmcUsersTable'
import { applyFiltersToList } from '../components/utils/utils'

export default {
  components: {
    IncludedFilter,
    Modal,
    Picklist,
    SLDSInput: Input,
    Spinner,
    UsersTable,
    SfmcUsersTable
  },
  async created () {
    try {
      this.settings = await this.$store.dispatch('settings/getSettings')
      this.users = await this.$store.dispatch('userManagement/getUsers')
      //this.sfmcUsers = await this.$store.dispatch('userManagement/getSfmcUsers')

      this.doFilter()

      this.$store.watch(
        (state, getters) => getters['userManagement/userList'],
        newValue => {
          this.users = newValue
          this.doFilter()
        },
        (state, getters) => getters['userManagement/sfmcUserList'],
        newValue => {
          this.sfmcUsers = newValue
          this.doFilter()
        },
        {
          deep: true
        }
      )
    } catch (err) {
      throw err
    }
  },
  data () {
    return {
      filteredUsers: [],
      filters: {
        active: '',
        countries: '',
        role: ''
      },
      searchKey: '',
      selectedUser: {},
      newUser: {
        name: '',
        email: '',
        countries: [],
        role: '',
        visibility: [],
        sub: "",
        locale:"",
        active:false
      },
      settings: {},
      showModal: false,
      showDeleteModal: false,
      showNewUserModal: false,
      showNewUserModal_getID: false,
      isPreviousButtonDisabled:true,
      isNextButtonDisabled:true,
      sortingOptions: {
        field: 'name',
        direction: 'asc'
      },
      users: [],
      sfmcUsers: []
    }
  },
  methods: {
    cancelUserEdit () {
      this.selectedUser = {}
      this.showModal = false
    },
    changeSortingOptions (event) {
      this.sortingOptions = event.sortingOptions
      this.doFilter()
    },
    closeModal () {
      this.showModal = false
      this.selectedUser = {}
    },
    //modifica Salvo 10/10/2024
    closeDeleteModal () {
      this.subToDelete = -1
      this.showDeleteModal = false
    },
    applyFilters: _.debounce((list, searchKey, filtersObject, fieldsToFilter, sortingOptions, callback) => applyFiltersToList(list, searchKey, filtersObject, fieldsToFilter, sortingOptions, callback), 300),
    doFilter () {
      this.applyFilters(this.users, this.searchKey, this.filters, ['name', 'email'], this.sortingOptions, (result) => { this.filteredUsers = result })
    },
    editRow (event) {
      this.selectedUser = JSON.parse(JSON.stringify(this.users.find(u => u.sfmcId === event.id)))
      this.showModal = true
    },
    async saveUser () {
      try {
        if (this.$refs.countries.validate()) {
          await this.$store.dispatch('userManagement/updateUser', this.selectedUser)
          this.selectedUser = {}
          this.showModal = false
          this.showToast('success', this.$t('usersManagement.updateSuccess'), 'text')
        }
      } catch (error) {
        console.error(error)
        this.showToast('error', this.$t('usersManagement.updateError'), 'text', error.toJSON().message)
      }
    },
    //MODIFICA SALVO 10/10/2024
    deleteUser (event) {
      this.selectedUser = JSON.parse(JSON.stringify(this.users.find(u => u.sfmcId === event.id)))
      this.showDeleteModal = true
    },
    async doDeleteUser () {
      try {
        //if (this.$refs.countries.validate()) {
          await this.$store.dispatch('userManagement/deleteUser', this.selectedUser)
          this.selectedUser = {}
          this.showDeleteModal = false
          this.showToast('success', this.$t('usersManagement.deleteSuccess'), 'text')
          //this.$emit('update') potrebbe servire se non aggiorna la lista
        //}
      } catch (error) {
        console.error(error)
        this.showToast('error', this.$t('usersManagement.deleteError'), 'text', error.toJSON().message)
      }
    },
    createNewUser (event) {
      /*this.newUser= {
        name: '',
        email: '',
        countries: [],
        role: '',
        visibility: [],
        sub:(Math.floor(100000000 + Math.random() * 900000000)).toString()
      },*/
      //this.newUser.sub = (Math.floor(100000000 + Math.random() * 900000000)).toString()
      this.showNewUserModal_getID = true
    },
    closeNewUserModal () {
      this.showNewUserModal = false
      this.showNewUserModal_getID = false
      this.newUser= {
                name: '',
                email: '',
                countries: [],
                role: '',
                visibility: [],
                sub: "",
                locale:"",
                active: false
              }
      //this.selectedUser = {}
      this.sfmcUsers = []
    },
    cancelNewUser () {
      //this.selectedUser = {}
      this.showNewUserModal = false
      this.showNewUserModal_getID = false
      
      this.newUser= {
                name: '',
                email: '',
                countries: [],
                role: '',
                visibility: [],
                sub: "",
                locale:"",
                active: false
              }
              
      this.sfmcUsers = []
    },
    async saveNewUser () {
      try {
        if (this.$refs.countries.validate() && this.$refs.locale && this.$refs.role) {
          await this.$store.dispatch('userManagement/newUser', this.newUser)
          this.newUser= {
                name: '',
                email: '',
                countries: [],
                role: '',
                visibility: [],
                sub: "",
                locale:"",
                active: false
              }
          this.sfmcUsers = []
          this.showNewUserModal = false
          this.showToast('success', this.$t('usersManagement.createSuccess'), 'text')
        }
      } catch (error) {
        console.error(error)
        this.showToast('error', this.$t('usersManagement.createError'), 'text', error.toJSON().message)
      }
    },
    async getNewUserSub () {
      try {
        //if (this.$refs.countries.validate()) {
          const accountToSearch = {email:this.newUser.email}
          this.newUser= {
                name: '',
                email: accountToSearch.email,
                countries: [],
                role: '',
                visibility: [],
                sub: "",
                locale:"",
                active: false
              }
          this.sfmcUsers = []
          const resp = await this.$store.dispatch('userManagement/getSfmcUserId', accountToSearch)
          if(resp && resp.body && resp.body.Results && resp.body.Results.length>0){
            this.sfmcUsers = resp.body.Results
            this.newUser.name = this.sfmcUsers[0].Name
            this.newUser.sub = this.sfmcUsers[0].ID
            this.newUser.email = this.sfmcUsers[0].Email
            if(this.sfmcUsers.length>1){
              this.isPreviousButtonDisabled=true
              this.isNextButtonDisabled=false
            }
          }
        //}
      } catch (error) {
        console.error(error)
        this.showToast('error', this.$t('usersManagement.searchError'), 'text', error.toJSON().message)
      }
    },
    async continueNewUser () {
      try {
        //if (this.$refs.countries.validate()) {
            this.showNewUserModal_getID = false
            this.showNewUserModal = true
        //}
      } catch (error) {
        console.error(error)
        this.showToast('error', this.$t('usersManagement.searchError'), 'text', error.toJSON().message)
      }
    },
    async backNewUser () {
      try {
        //if (this.$refs.countries.validate()) {
            this.showNewUserModal_getID = true
            this.showNewUserModal = false
            this.newUser.countries=[]
            this.newUser.role=''
            this.newUser.visibility=[]
            this.newUser.locale=''
            this.newUser.active=false
        //}
      } catch (error) {
        console.error(error)
        this.showToast('error', this.$t('usersManagement.searchError'), 'text', error.toJSON().message)
      }
    },
    async goToPreviousSfmcUser () {
      const newUserIndex = this.sfmcUsers.findIndex(u => u.ID === this.newUser.sub)
      this.newUser.name = this.sfmcUsers[newUserIndex-1].Name
      this.newUser.sub = this.sfmcUsers[newUserIndex-1].ID
      this.newUser.email = this.sfmcUsers[newUserIndex-1].Email
      this.isNextButtonDisabled=false
      if(newUserIndex==1){
        this.isPreviousButtonDisabled=true
      }
    },
    async goToNextSfmcUser () {
      const newUserIndex = this.sfmcUsers.findIndex(u => u.ID === this.newUser.sub)
      this.newUser.name = this.sfmcUsers[newUserIndex+1].Name
      this.newUser.sub = this.sfmcUsers[newUserIndex+1].ID
      this.newUser.email = this.sfmcUsers[newUserIndex+1].Email
      this.isPreviousButtonDisabled=false
      if(newUserIndex+1==this.sfmcUsers.length-1){
        this.isNextButtonDisabled=true
      }
    },
    //MODIFICA SALVO 10/10/2024
    deleteUser (event) {
      this.selectedUser = JSON.parse(JSON.stringify(this.users.find(u => u.sfmcId === event.id)))
      this.showDeleteModal = true
    },
    async doDeleteUser () {
      try {
        //if (this.$refs.countries.validate()) {
          await this.$store.dispatch('userManagement/deleteUser', this.selectedUser)
          this.selectedUser = {}
          this.showDeleteModal = false
          this.showToast('success', this.$t('usersManagement.deleteSuccess'), 'text')
          //this.$emit('update') potrebbe servire se non aggiorna la lista
        //}
      } catch (error) {
        console.error(error)
        this.showToast('error', this.$t('usersManagement.deleteError'), 'text', error.toJSON().message)
      }
    }
  },
  watch: {
    async searchKey (searchKey) {
      this.applyFilters(this.users, searchKey, this.filters, ['name', 'email'], this.sortingOptions, (result) => { this.filteredUsers = result })
    },
    filters: {
      handler: function (value) {
        this.applyFilters(this.users, this.searchKey, value, ['name', 'email'], this.sortingOptions, (result) => { this.filteredUsers = result })
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.filter-panel {
  margin-bottom: 10px;
}

.row {
  display: flex;
  flex-direction: row;

  & .slds-form-element {
    flex-grow: 1;

    &:not(:last-child) {
      margin-right: 10px;
    }
  }
}
#btn_searchSfmcUser {
  height: fit-content;
  padding: 0.25rem;
  margin-left: -1.5rem;
}
#input_searchSfmcUser {
  width: -webkit-fill-available;
}
#div_PaginationSearchSfmcUser {
  text-align: center;
}
</style>
